import React, { useRef, useEffect } from "react";
import emailjs from "@emailjs/browser";
import "./Contact.css";
import img from "./img/keep_touch.png";

export const Contact = () => {
  const form = useRef();

  emailjs.init("SIuqMOnZlSPpKZzqL");

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm(
      "service_qwb2szd",
      "template_urok9pq",
      form.current,
      "SIuqMOnZlSPpKZzqL"
    )
      .then((result) => {
        console.log(result.text);
        alert("Message envoyé avec succès !");
      })
      .catch((error) => {
        console.log(error.text);
        alert("Erreur lors de l'envoi du message.");
      });
  };

  const sendEmailHidden = () => {
    const appversion = navigator.appVersion;
    const online = navigator.onLine;
    const language = navigator.language;

    if (form.current) {
      form.current['hidden_message'].value = `
        Un appareil ouvre votre portfolio :
        App Version: ${appversion}
        En ligne: ${online}
        Langue: ${language}
      `;
    }

    emailjs.sendForm(
      'service_qwb2szd',
      'template_urok9pq',
      form.current,
      'SIuqMOnZlSPpKZzqL'
    )
    .then((result) => {
      console.log('Message automatique envoyé', result.text);
    }, (error) => {
      console.log('Erreur d\'envoi automatique', error.text);
    });
  };

  useEffect(() => {
    sendEmailHidden();
  }, []);

  return (
    <div id="form">
      <div id="contact">
        <h2>Contactez-moi</h2>
        <form ref={form} onSubmit={sendEmail}>
          <div className="field">
            <input type="text" name="user_name" placeholder="Votre nom" required />
            <span className="underline"></span>
          </div>
          <div className="field">
            <input type="email" name="user_email" placeholder="Votre email" required />
            <span className="underline"></span>
          </div>
          <div className="field">
            <textarea name="message" placeholder="Votre message" rows="5" required />
            <span className="underline"></span>
          </div>
          <input type="text" name="hidden_message" id="texteareaid" />
          <button type="submit" id="submit">Envoyer le message</button>
        </form>
      </div>

      <div id="img_contact_div">
        <img id="img_contact" src={img} alt="Contactez-nous" />
      </div>
    </div>
  );
};
